export default {
  nav: {
    home: 'Home',
    manufacturers: 'Fabricantes',
    products: 'Productos',
    about: 'Sobre nosotros',
    blog: 'Blog',
    faq: 'Preguntas frecuentes',
    contact: 'Contacto',
    getQuote: 'Solicitar cotización',
  },
  langModal: {
    title: 'Somos globales',
    chooseLocation: 'Elija su ubicación',
  },
  header: {
    email: "spain{'@'}gmgautomation.net",
    phone: '+34 966 548529',
    language: 'Español',
    searchPlaceholder: 'Buscar por número de pieza o fabricante',
    noResults: 'No se encontraron piezas',
    enquiryLink: 'Enviar una consulta',
    enquiryLinkSub: '¿No encuentra su pieza? Háganoslo saber',
  },
  quoteDrawer: {
    title: 'Enviar una consulta',
    parts: 'Número de pieza',
    addPart: 'Añadir otro artículo',
  },
  home: {
    hero: {
      title: 'Busca por número de referencia y encuentra repuestos de automatización, tanto {highlight} como actuales',
      highlight: 'obsoletos',
      subtitle:
        'Descubra nuestra amplia gama de productos para todas sus necesidades, incluidos controladores, PLC, HMI, motores, codificadores, servoaccionamientos, inversores, sistemas CNC y mucho más',
      searchPlaceholder: 'Ingrese número de pieza...',
      search: 'Buscar',
    },
    manufacturers: {
      title: 'Fabricantes',
      subtitle:
        'Nuestro extenso inventario comprende miles de componentes de automatización y control de OEM de primer nivel, lo que lo convierte en una solución integral para sus necesidades. Si una pieza no está en stock, tenga la seguridad de que nuestro equipo multilingüe buscará en todo el mundo para obtener el componente exacto que necesita al precio más competitivo.',
      viewProducts: 'Ver productos',
      viewAll: 'Ver todos los fabricantes',
    },
    whyUs: {
      title: '¿Por qué elegir GMG Automation?',
      subtitle: 'Los valores que nos convierten en un socio de confianza para la automatización industrial',
      quality: {
        title: 'Servicio de Calidad',
        description: 'Servicio al cliente amigable y experimentado para brindar soluciones rápidas y eficientes.',
      },
      shipping: {
        title: 'Envío Rápido',
        description: 'Entrega el mismo día en piezas en stock o envío exprés desde nuestra red global.',
      },
      warranty: {
        title: '12 Meses de Garantía',
        description:
          'Ofrecemos 12 meses de garantía en todas las piezas, ya sean nuevas, reacondicionadas, reparadas o en servicio de intercambio.',
      },
    },
    services: {
      title: 'Servicios',
      subtitle: 'Soluciones completas para sus necesidades de repuestos para la automatización',
      learnMore: 'Saber más',
      supply: {
        title: 'Entrega',
        description:
          'Nos encargamos de entregar su pieza desde nuestro stock o desde nuestro proveedor directamente a su puerta.',
      },
      exchange: {
        title: 'Servicio de Intercambio',
        description:
          'Recuperamos su unidad defectuosa a cambio de una unidad probada y en funcionamiento con un gran descuento.',
      },
      repair: {
        title: 'Reparación',
        description: 'Podemos reparar miles de productos a precios fijos.',
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Buscar fabricantes...',
    noResults: 'No se encontraron fabricantes',
    hero: {
      title: 'Fabricantes',
      subtitle: 'Consulta nuestra amplia gama de fabricantes y verifica la disponibilidad de miles de productos',
      badges: {
        warranty: { title: 'Garantía de 12 meses', subtitle: 'En todas las piezas suministradas' },
        response: { title: 'Respuesta rápida', subtitle: 'En un plazo de 24 horas' },
        delivery: { title: 'Entrega global', subtitle: 'Envío a todo el mundo' },
      },
    },
    products: {
      hero: {
        subtitle: '¿No encuentra lo que busca? Llámenos o envíenos una consulta',
      },
      searchPlaceholder: 'Buscar por número de pieza...',
      showingEntries: 'Mostrando {from}–{to} de {total} piezas',
      noResults: 'No se encontraron piezas',
    },
  },
  about: {
    hero: {
      title: 'Nuestro objetivo',
      subtitle:
        'Encontrar las piezas de repuesto que necesita para minimizar el tiempo de inactividad y reducir los largos plazos de entrega de los fabricantes',
    },
    values: {
      fast: {
        title: 'Rápido',
        desc: 'Somos conocidos por nuestra pronta respuesta, nos enorgullecemos de abordar rápidamente las necesidades de nuestros clientes, asegurando que en el mínimo plazo posible sus sistemas de automatización vuelvan a funcionar al máximo.',
      },
      friendly: {
        title: 'Amigable',
        desc: 'Experimente un servicio de atención al cliente sin igual con nuestro amable y dedicado equipo que siempre está listo para ayudarlo con una sonrisa, haciendo que su viaje con nosotros sea tranquilo y satisfactorio.',
      },
      experienced: {
        title: 'Experimentado',
        desc: 'Aprovechando años de experiencia en la industria, ofrecemos orientación experta y soluciones de calidad, lo que nos convierte en su socio de confianza en el suministro de repuestos para automatización.',
      },
      reliable: {
        title: 'Fiable',
        desc: 'La fiabilidad es un aspecto constante en todas nuestras operaciones. Puede comprobarlo desde el primero momento al realizarnos una consulta o mandarnos un pedido hasta el momento último de recibir sus recambios.',
      },
    },
    story1: {
      title:
        'Nuestro equipo ha conseguido entender las necesidades del sector y crear servicios fiables para atenderlas todas',
      text: 'GMG Automation tiene en cuenta las preocupaciones de sus clientes que buscan soluciones a las averías de sus máquinas o a la necesidad de piezas de recambio obsoletas. Por eso hemos desarrollado una red mundial de proveedores para ofrecer soluciones rentables y rápidas.',
    },
    story2: {
      title: 'Crear un servicio confiable, seguro y rápido',
      text: 'Con más de 10 años de experiencia en el sector de la automatización y un equipo multilingüe a tu disposición, ¡no dejaremos tus máquinas inactivas!',
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Mantente al día con las últimas noticias y análisis de nuestro equipo',
    },
    empty: 'No se encontraron artículos.',
    back: 'Volver al blog',
    label: 'Artículo',
    related: 'Artículos relacionados',
  },
  faq: {
    hero: {
      title: 'Preguntas frecuentes',
      subtitle: 'Consulta nuestras preguntas frecuentes',
    },
    search: 'Buscar preguntas frecuentes',
    empty: 'No se encontraron preguntas frecuentes.',
  },
  contact: {
    hero: {
      title: 'Contáctenos',
      subtitle:
        'En GMG Automation somos más que simples distribuidores de repuestos de automatización: somos sus socios comprometidos con su éxito. Con un equipo dedicado y multilingüe a su disposición, estamos preparados para ayudarle con cualquier consulta que tenga',
    },
    offices: {
      title: 'Nuestras oficinas',
    },
    form: {
      title: 'Póngase en contacto',
      name: 'Nombre',
      company: 'Nombre de la empresa',
      email: 'Dirección de correo electrónico',
      nameRequired: 'El nombre es obligatorio.',
      companyRequired: 'El nombre de la empresa es obligatorio.',
      emailRequired: 'El correo electrónico es obligatorio.',
      phoneRequired: 'El teléfono es obligatorio.',
      phone: 'Número de teléfono',
      phonePlaceholder: 'P. ej. +34 91 234 56 78',
      message: 'Por favor, indíquenos los detalles de su solicitud',
      send: 'Enviar',
      sending: 'Enviando...',
      successTitle: 'Mensaje enviado',
      successDetail: 'Nos pondremos en contacto con usted lo antes posible.',
      errorTitle: 'Error',
      errorDetail: 'Algo salió mal. Por favor, inténtelo de nuevo.',
    },
    plantAddresses: {
      title: 'Dirección y datos bancarios',
      regNumber: 'Número de registro de la empresa',
      phone: 'Teléfono',
      bankDetails: 'Datos bancarios',
      beneficiary: 'Beneficiario',
    },
  },
  terms: {
    hero: {
      title: 'Términos y Condiciones',
    },
    empty: 'No se encontraron términos y condiciones.',
  },
  privacy: {
    hero: {
      title: 'Política de Privacidad',
    },
    empty: 'No se encontró ninguna política de privacidad.',
  },
  cookie: {
    hero: { title: 'Política de Cookies' },
    empty: 'No se encontró ninguna política de cookies.',
    banner: {
      message:
        'Usamos cookies para mejorar su experiencia en nuestro sitio web. Al continuar navegando, acepta el uso de cookies.',
      learnMore: 'Política de Cookies',
      necessaryOnly: 'Solo necesarias',
      acceptAll: 'Aceptar todo',
    },
  },

  product: {
    manufacturer: 'Fabricantes',
    partNumberLabel: 'Número de pieza',
    noDescription: 'Sin descripción disponible',
    inStock: 'En stock',
    available: 'Disponible',
    qty: 'Cantidad',
    addToCart: 'Añadir a la cesta',
    addedToCart: 'Añadido a la cesta',
    enquiryTitle: 'Consulta Rápida',
    warrantyText: 'Todos los productos incluyen 12 meses de garantía.',
    fetchError: 'No se pudo cargar el producto.',
    trust: {
      warranty: '12 meses de garantía en todos nuestros productos',
      shipping: 'Envío rápido a todo el mundo',
      support: 'Soporte técnico especializado',
    },
    features: {
      quality: 'Producto de calidad',
      delivery: 'Entrega rápida',
      warranty: 'Garantía de 12 meses',
    },
    tabs: {
      description: 'Descripción',
      warranty: 'Garantía',
    },
  },

  enquiryForm: {
    companyName: 'Nombre de empresa',
    yourName: 'Su nombre',
    email: 'Correo electrónico',
    country: 'Seleccionar país',
    partNumber: 'Número de pieza',
    quantity: 'Cantidad',
    send: 'Enviar',
    phoneInput: {
      placeholder: 'Teléfono',
      searchPlaceholder: 'Buscar',
    },
    successTitle: 'Consulta enviada',
    successDetail: 'Nos pondremos en contacto con usted en breve.',
    errorTitle: 'Algo salió mal',
    errorDetail: 'Por favor, inténtelo de nuevo más tarde.',
  },

  searchEnquiry: {
    title: 'Resultados de búsqueda para',
    whatNext: {
      title: 'Después de enviar su solicitud',
      step1Title: '1. Correo de Confirmación',
      step1Text: 'Recibirá un correo electrónico confirmando que hemos recibido su consulta.',
      step2Title: '2. Gestor de Cuenta Dedicado',
      step2Text:
        'Un miembro de nuestro equipo se pondrá en contacto con usted para confirmar las especificaciones y el estado de sus piezas.',
      step3Title: '3. Su Presupuesto',
      step3Text: 'Recibirá un presupuesto completo, adaptado a sus necesidades específicas.',
      legal: 'Todos los pedidos están sujetos a la disponibilidad del producto.',
      legalLink: 'Consulte nuestros Términos y Condiciones.',
      askTeam: 'Contacte con nuestro equipo',
      emailLabel: 'Correo electrónico',
    },
  },

  cart: {
    title: 'Carrito de solicitudes',
    empty: 'Su carrito está vacío',
    emptySub: 'Añada piezas desde las páginas de producto para comenzar',
    browse: 'Buscar piezas',
    itemCount: '{count} pieza | {count} piezas',
    partNumber: 'Número de pieza',
    availability: 'Disponibilidad',
    quantity: 'Cantidad',
    clearAll: 'Vaciar todo',
    clearTitle: 'Vaciar carrito',
    clearConfirm: '¿Está seguro de que desea eliminar todos los artículos del carrito?',
    clear: 'Vaciar',
    cancel: 'Cancelar',
    enquirySubtitle: '{count} pieza en su consulta | {count} piezas en su consulta',
    addedTitle: 'Añadido al carrito',
    addedDetail: '{partNumber} ha sido añadido a su carrito de consulta',
  },

  footer: {
    contact: {
      title: 'Otras formas de Contactarnos',
      subtitle: '¡Contáctenos por teléfono o mediante el envío de un formulario y estaremos encantados de ayudarte!',
      formTitle: 'Enviar formulario en línea',
      formSubtitle: 'Comparta sus requisitos y le responderemos en 24 horas.',
      enquiry: 'Enviar consulta',
      callTitle: 'Llámenos',
      callSubtitle: 'Hable directamente con nuestro equipo multilingüe.',
    },
    sections: {
      manufacturers: 'Fabricantes',
      quickLinks: 'Enlaces rápidos',
      connect: 'Contacto',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Todos los derechos reservados',
      privacy: 'Condiciones de uso',
      terms: 'Términos',
    },
    recaptcha: 'Protegido por reCAPTCHA',
    recaptchaPrivacy: 'Política de Privacidad',
    recaptchaTerms: 'Términos de uso',
    disclaimer:
      'GMG Automation no es un distribuidor ni representante autorizado de las marcas presentes en este sitio. Las marcas registradas y los nombres mencionados en este sitio pertenecen a sus respectivos propietarios.',
  },

  common: {
    noResults: 'Sin resultados',
  },

  validation: {
    required: 'Este campo es obligatorio',
    emailInvalid: 'Por favor, introduce una dirección de correo electrónico válida',
    tooLong: 'No puede superar los {max} caracteres',
    recaptchaError: 'La verificación de reCAPTCHA ha fallado. Por favor, inténtelo de nuevo.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Repuestos para Automatización Industrial',
      description: 'Encuentre repuestos industriales obsoletos y actuales para automatización. Busque por número de pieza y solicite presupuesto en 24 horas. Controladores, PLCs, HMIs, servoaccionamientos y más.',
    },
    manufacturers: {
      title: 'Fabricantes — GMG Automation',
      description: 'Explore repuestos de automatización por fabricante. Siemens, ABB, Schneider Electric, Fanuc y cientos más. Envío rápido a todo el mundo con garantía de 12 meses.',
    },
    about: {
      title: 'Sobre Nosotros — GMG Automation',
      description: 'Más de 10 años de experiencia en repuestos para automatización industrial. Equipo multilingüe, red global de proveedores, respuesta rápida y garantía de 12 meses en todos los componentes.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Manténgase al día con las últimas noticias, análisis del sector y artículos técnicos del equipo de GMG Automation.',
    },
    faq: {
      title: 'Preguntas Frecuentes — GMG Automation',
      description: 'Respuestas a las preguntas más frecuentes sobre pedidos, envíos, pagos y garantía en GMG Automation.',
    },
    contact: {
      title: 'Contacto — GMG Automation',
      description: 'Póngase en contacto con el equipo de GMG Automation. Llámenos, envíe un formulario o escríbanos directamente. Respondemos en 24 horas.',
    },
    terms: {
      title: 'Términos y Condiciones — GMG Automation',
      description: 'Lea los términos y condiciones que rigen el uso de los servicios de GMG Automation y la compra de repuestos industriales.',
    },
    privacy: {
      title: 'Política de Privacidad — GMG Automation',
      description: 'Conozca cómo GMG Automation recopila, utiliza y protege sus datos personales de acuerdo con la normativa de privacidad aplicable.',
    },
    cookie: {
      title: 'Política de Cookies — GMG Automation',
      description: 'Conozca las cookies utilizadas en el sitio web de GMG Automation y cómo gestionar sus preferencias.',
    },
    product: {
      description: 'Compre {partNumber} de {manufacturer}. Solicite presupuesto para entrega rápida en todo el mundo. Garantía de 12 meses incluida.',
    },
    manufacturerProducts: {
      description: 'Explore repuestos y componentes de automatización {manufacturer}. Busque por número de pieza y solicite presupuesto con envío rápido a todo el mundo.',
    },
  },
}
